// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let ShowingCard = require("./ShowingCard.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertyShowingsList_showing_graphql = require("../../../__generated__/PropertyShowingsList_showing_graphql.bs.js");
let PropertyShowingsList_showings_graphql = require("../../../__generated__/PropertyShowingsList_showings_graphql.bs.js");

let convertFragment = PropertyShowingsList_showing_graphql.Internal.convertFragment;

function PropertyShowingsList$Card(props) {
  let showing = RescriptRelay_Fragment.useFragment(PropertyShowingsList_showing_graphql.node, convertFragment, props.showing);
  let date = showing.startDateV2.toLocaleString("en-us", {
    weekday: "short",
    month: "short",
    day: "numeric"
  });
  let startTime = showing.startDateV2.toLocaleString("en-us", {
    hour: "numeric",
    minute: "numeric"
  });
  let endTime = showing.endDateV2.toLocaleString("en-us", {
    hour: "numeric",
    minute: "numeric"
  });
  let match = showing.type_;
  let badgeText;
  if (match === "AGENTS_ONLY" || match === "TAN_ONLY" || match === "BUYERS_WELCOME") {
    switch (match) {
      case "AGENTS_ONLY" :
        badgeText = "Agents only";
        break;
      case "BUYERS_WELCOME" :
        badgeText = "Buyers welcome";
        break;
      case "TAN_ONLY" :
        badgeText = "TAN only";
        break;
    }
  } else {
    badgeText = undefined;
  }
  return JsxRuntime.jsx(ShowingCard.make, {
    date: date,
    dateIcon: Primitive_option.some(showing.startDateV2.toPlainDate()),
    time: startTime + ` - ` + endTime,
    badgeText: badgeText,
    notes: showing.notes,
    showNotes: props.shouldShowPropertyDetails
  });
}

let convertFragment$1 = PropertyShowingsList_showings_graphql.Internal.convertFragment;

function PropertyShowingsList(props) {
  let shouldShowPropertyDetails = props.shouldShowPropertyDetails;
  let showings = RescriptRelay_Fragment.useFragment(PropertyShowingsList_showings_graphql.node, convertFragment$1, props.showings);
  let match = showings.length;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("h2", {
        children: "Showings",
        className: "text-2xl font-medium text-zinc-800"
      }),
      JsxRuntime.jsx("div", {
        children: match !== 0 ? showings.map(showing => JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(PropertyShowingsList$Card, {
              showing: showing.fragmentRefs,
              shouldShowPropertyDetails: shouldShowPropertyDetails
            }),
            className: "max-w-md md:max-w-none"
          }, showing.id)) : "There are no scheduled showings.",
        className: "grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6 items-stretch my-4"
      })
    ]
  });
}

let Card = {
  make: PropertyShowingsList$Card
};

let make = PropertyShowingsList;

exports.Card = Card;
exports.make = make;
/* ShowingCard Not a pure module */
